<template>
	<div>
		<top-nav></top-nav>
		<nav class="nav-tabs">
			<ul>
				<li :class="activeTab === title ? 'active' : ''" @click="changeTab(title)" v-for="title in tabs">
					<a> {{ title }}</a>
				</li>
			</ul>
		</nav>

		<div class="main">
			<translation-lister v-if="activeTab === 'translations'"></translation-lister>
			<translation-summary-settings-lister v-if="activeTab === 'summary settings'"></translation-summary-settings-lister>
			<translation-properties-lister v-if="activeTab === 'properties'"></translation-properties-lister>
		</div>
	</div>
</template>

<script>


import {eventBus} from "../../app";

export default {

	props: {},

	data() {
		return {
			activeTab: 'translations',
			tabs: [
				'translations',
				'summary settings',
				'properties'
			],

			userRoles: this.$currentUserRoles,
			showOnly: {
				important: true
			},

		}
	},

	created() {
		this.loadParameters();
	},

	methods: {

		changeTab: function (name) {
			this.activeTab = name;
			this.updateUrl(name);
		},

		loadParameters: function () {
			let tab = this.getParameterByName('tab');
			if (tab !== null) {
				this.changeTab(tab);
			}
		},
		getParameterByName: function (name, url) {
			if (!url) url = window.location.href;
			name = name.replace(/[\[\]]/g, '\\$&');
			let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
					results = regex.exec(url);
			if (!results) return null;
			if (!results[2]) return '';
			return decodeURIComponent(results[2].replace(/\+/g, ' '));
		},
		updateUrl: function (clean = false) {
			let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
			let parameters = window.location.search.substr(1).split('&');

			let newParams = [];
			parameters.forEach(function (parameter, index) {
				if (!parameter.includes('tab=')) {
					newParams.push(parameter);
				}
			});

			newParams.unshift('tab=' + this.activeTab);


			if (newParams.length > 0) {
				newParams = newParams.join('&');
				newurl += '?' + newParams;
			}
			window.history.pushState({path: newurl}, '', newurl);
		},

	}
}
</script>

